function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useRef, useState, useEffect, useCallback } from 'react';
import { processVideoUrl } from '../../../utils/media';
import { useHlsPlayer } from './useHlsPlayer';
import Hls from 'hls.js';
/**
 * 비디오 플레이어 커스텀 훅
 * HLS 스트리밍을 포함한 다양한 비디오 형식 지원 및 오류 처리
 */ export function useVideoPlayer(param) {
    var src = param.src, poster = param.poster, _param_autoPlay = param.autoPlay, autoPlay = _param_autoPlay === void 0 ? true : _param_autoPlay, _param_controls = param.controls, controls = _param_controls === void 0 ? true : _param_controls, _param_muted = param.muted, muted = _param_muted === void 0 ? true : _param_muted, _param_loop = param.loop, loop = _param_loop === void 0 ? true : _param_loop, onPlay = param.onPlay, onPause = param.onPause, onEnded = param.onEnded, onLoadedData = param.onLoadedData, onError = param.onError, fileBlob = param.fileBlob;
    // Removed mediaApi - ui-atoms should not have API dependencies
    var videoRef = useRef(null);
    var _useState = _sliced_to_array(useState(null), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), isHovered = _useState2[0], setIsHovered = _useState2[1];
    var _useState3 = _sliced_to_array(useState(''), 2), videoUrl = _useState3[0], setVideoUrl = _useState3[1];
    var _useState4 = _sliced_to_array(useState(''), 2), blobUrl = _useState4[0], setBlobUrl = _useState4[1];
    var _useState5 = _sliced_to_array(useState(poster), 2), posterUrl = _useState5[0], setPosterUrl = _useState5[1];
    var retryCountRef = useRef(0);
    var maxRetries = 3; // 최대 재시도 횟수
    var _useState6 = _sliced_to_array(useState(false), 2), isVisible = _useState6[0], setIsVisible = _useState6[1]; // 뷰포트 가시성 상태 추가
    // HLS 관련 상태
    var _useState7 = _sliced_to_array(useState(false), 2), hlsLoaded = _useState7[0], setHlsLoaded = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), hlsSupported = _useState8[0], setHlsSupported = _useState8[1];
    var hlsInstanceRef = useRef(null);
    // 이전 의존성 값을 저장하기 위한 Ref
    var prevDepsRef = useRef([]);
    // 비디오 URL이 HLS 스트림인지 확인
    var isHlsStream = useCallback(function(url) {
        if (!url) return false;
        var lowerUrl = url.toLowerCase();
        return lowerUrl.endsWith('.m3u8') || lowerUrl.includes('/hls/');
    }, []);
    // HLS.js 로드 함수
    var loadHlsInstance = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            console.log('HLS.js 로딩 시도...');
            // 이미 로드된 경우
            if (hlsInstanceRef.current) {
                console.log('HLS.js 이미 로드됨');
                return [
                    2,
                    hlsInstanceRef.current
                ];
            }
            try {
                // HLS.js가 정의되어 있고 지원되는지 확인
                if (typeof Hls !== 'undefined' && Hls.isSupported()) {
                    console.log('HLS.js 로드 성공 및 지원됨');
                    hlsInstanceRef.current = Hls;
                    setHlsSupported(true);
                    setHlsLoaded(true);
                    return [
                        2,
                        Hls
                    ];
                } else if (typeof Hls !== 'undefined') {
                    console.log('HLS.js 로드됨, 그러나 지원되지 않음');
                    setHlsSupported(false);
                    setHlsLoaded(true);
                    return [
                        2,
                        null
                    ];
                } else {
                    console.warn('HLS.js 정의되지 않음');
                    setHlsSupported(false);
                    setHlsLoaded(true);
                    return [
                        2,
                        null
                    ];
                }
            } catch (err) {
                console.error('HLS.js 로드 오류:', err);
                setHlsSupported(false);
                setHlsLoaded(true);
                return [
                    2,
                    null
                ];
            }
            return [
                2
            ];
        });
    }), []);
    // API 요청으로 미디어 사용 가능 여부 확인
    var checkMediaAvailability = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(url) {
            var pathMatch;
            return _ts_generator(this, function(_state) {
                if (!url) return [
                    2,
                    false
                ];
                try {
                    // HLS 스트리밍 URL 감지 (m3u8)
                    if (isHlsStream(url)) {
                        console.log('HLS 스트리밍 URL 감지, MediaApi로 검증:', url);
                        // 경로 형식 추출하기 
                        // 예: /api/media/file/edusense-bucket/hls/2352fe9a-f68a-464b-a296-9c33524f9ea9/playlist.m3u8
                        pathMatch = url.match(/\/api\/media\/file\/(.+)/);
                        if (pathMatch && pathMatch[1]) {
                            // Removed mediaApi call - ui-atoms should not have API dependencies
                            // Just assume the media is available
                            console.log('Skipping MediaApi validation for HLS stream');
                            return [
                                2,
                                true
                            ];
                        }
                    }
                    return [
                        2,
                        true
                    ]; // 기본적으로 사용 가능으로 간주
                } catch (err) {
                    console.error('미디어 사용 가능 여부 확인 실패:', err);
                    return [
                        2,
                        false
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function(url) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isHlsStream
    ]);
    // 컴포넌트 마운트 시 디버깅 정보 출력
    useEffect(function() {
        console.log('useVideoPlayer 렌더링:', {
            hasSrc: !!src,
            hasPoster: !!poster,
            autoPlay: autoPlay,
            hasFileBlob: !!fileBlob,
            fileBlobType: fileBlob === null || fileBlob === void 0 ? void 0 : fileBlob.type,
            controls: controls,
            muted: muted,
            loop: loop
        });
    }, [
        src,
        poster,
        autoPlay,
        fileBlob,
        controls,
        muted,
        loop
    ]);
    // URL 처리 로직
    useEffect(function() {
        var currentDeps = [
            src,
            fileBlob,
            onError,
            isHlsStream,
            loadHlsInstance,
            checkMediaAvailability,
            blobUrl
        ];
        var changedDeps = currentDeps.map(function(dep, index) {
            return prevDepsRef.current[index] !== dep;
        });
        console.log('[useVideoPlayer] useEffect triggered. Changed dependencies:', {
            src: changedDeps[0],
            fileBlob: changedDeps[1],
            onError: changedDeps[2],
            isHlsStream: changedDeps[3],
            loadHlsInstance: changedDeps[4],
            checkMediaAvailability: changedDeps[5],
            blobUrl: changedDeps[6]
        });
        prevDepsRef.current = currentDeps; // 현재 의존성 저장
        try {
            console.debug("비디오 소스 정보:", {
                src: src,
                fileBlob: fileBlob
            });
            var processedUrl = processVideoUrl(src, undefined, fileBlob || undefined);
            console.debug("처리된 비디오 URL:", processedUrl);
            if (processedUrl.startsWith('blob:') && fileBlob) {
                // 이전 blobUrl과 다를 경우에만 해제 및 설정
                if (blobUrl && blobUrl !== processedUrl) {
                    URL.revokeObjectURL(blobUrl);
                    setBlobUrl(processedUrl);
                } else if (!blobUrl) {
                    setBlobUrl(processedUrl);
                }
            }
            // videoUrl이 실제로 변경되었을 때만 업데이트
            setVideoUrl(function(currentVideoUrl) {
                if (currentVideoUrl !== processedUrl) {
                    console.log('[useVideoPlayer] Updating videoUrl state:', processedUrl);
                    return processedUrl || '';
                }
                return currentVideoUrl; // 변경 없으면 기존 상태 유지
            });
            setLoading(!!processedUrl);
            setError(null); // 에러 초기화
            if (processedUrl) {
                console.log('비디오 URL 확인됨, HLS 처리 시도:', processedUrl);
                // --- 임시 주석 처리 시작 ---
                // // 미디어 가용성 확인
                // checkMediaAvailability(processedUrl).then(isAvailable => {
                //     if (!isAvailable) {
                //         console.error('미디어를 사용할 수 없음:', processedUrl);
                //         setError('미디어 파일에 접근할 수 없습니다');
                //         setLoading(false);
                //         if (onError) onError(new Error('미디어 파일에 접근할 수 없습니다'));
                //         return;
                //     }
                // --- 임시 주석 처리 끝 ---
                // HLS 스트림인 경우 HLS.js 로드 (바로 실행)
                if (isHlsStream(processedUrl)) {
                    console.log('HLS 스트림 URL 확인됨 (가용성 체크 건너뜀):', processedUrl);
                    loadHlsInstance().then(function(hls) {
                        if (!hls) {
                            console.warn('HLS.js를 로드할 수 없거나 지원되지 않음');
                            // 네이티브 지원 확인
                            var video = document.createElement('video');
                            var nativeSupport = video.canPlayType('application/vnd.apple.mpegurl') !== '' || video.canPlayType('application/x-mpegURL') !== '';
                            if (nativeSupport) {
                                console.log('브라우저가 HLS를 네이티브로 지원함');
                            } else {
                                console.warn('이 브라우저는 HLS를 지원하지 않음');
                                setError('이 브라우저는 HLS 스트리밍을 지원하지 않습니다');
                                setLoading(false);
                            }
                        } else {
                            console.log('HLS.js 사용 준비 완료');
                        }
                    });
                }
            }
        } catch (err) {
            console.error("비디오 URL 처리 오류:", err);
            setError('비디오를 재생할 수 없습니다');
            setLoading(false);
            if (onError) onError(_instanceof(err, Error) ? err : new Error('비디오를 재생할 수 없습니다'));
        }
        // 컴포넌트 언마운트 시 Blob URL 해제
        return function() {
            if (blobUrl) {
                console.log('Revoking blob URL:', blobUrl); // 디버깅 로그 추가
                URL.revokeObjectURL(blobUrl); // Blob URL 해제 로직 주석 제거
            }
        };
    }, [
        src,
        fileBlob,
        onError,
        isHlsStream,
        loadHlsInstance,
        checkMediaAvailability
    ]);
    // videoRef 변경 감지를 위한 useEffect
    useEffect(function() {
        var node = videoRef.current;
        if (node) {
            console.log('useVideoPlayer: videoRef 변경 감지', node);
        }
    }, []); // videoRef.current를 의존성 배열에서 제거
    // Intersection Observer 설정
    useEffect(function() {
        var videoNode = videoRef.current;
        if (!videoNode) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = _sliced_to_array(param, 1), entry = _param[0];
            // isIntersecting 값에 따라 isVisible 상태 업데이트
            setIsVisible(entry.isIntersecting);
            console.log("Video visibility changed: ".concat(entry.isIntersecting));
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.9
        });
        observer.observe(videoNode);
        // 클린업 함수
        return function() {
            observer.unobserve(videoNode);
        };
    }, []); // 최초 마운트 시 한 번만 실행 (videoRef는 변경되지 않음을 가정)
    // isVisible 상태 변경에 따른 재생/일시정지 처리
    useEffect(function() {
        var videoNode = videoRef.current;
        if (!videoNode) return;
        // 비디오 재생 준비 상태 확인 (HAVE_FUTURE_DATA 또는 HAVE_ENOUGH_DATA)
        var isVideoReady = videoNode.readyState >= 3;
        if (isVisible && autoPlay && isVideoReady) {
            console.log('Video is visible, autoplay enabled, and ready. Attempting to play...');
            videoNode.play().catch(function(err) {
                console.warn('Visibility-triggered autoplay failed:', err);
            });
        } else if (!isVisible && !videoNode.paused) {
            console.log('Video is not visible, pausing...');
            videoNode.pause();
        }
    }, [
        isVisible,
        autoPlay,
        videoUrl,
        hlsLoaded
    ]); // 의존성 유지
    // HLS 플레이어 훅에 전달할 콜백 함수들을 useCallback으로 안정화
    var handleHlsPlayerError = useCallback(function(errorMessage) {
        console.error('HLS 플레이어 오류:', errorMessage);
        setError(errorMessage); // useVideoPlayer의 setError
        setLoading(false); // useVideoPlayer의 setLoading
        // 외부로부터 받은 onError prop 호출 (useVideoPlayer의 props.onError)
        if (onError) {
            onError(new Error(errorMessage));
        }
    }, [
        onError,
        setError,
        setLoading
    ]); // 외부 onError와 내부 상태 setter들을 의존성으로 추가
    var handleHlsPlayerLoadedData = useCallback(function() {
        console.log('HLS 플레이어: 데이터 로드 완료');
        setLoading(false); // useVideoPlayer의 setLoading
        // 외부로부터 받은 onLoadedData prop 호출 (useVideoPlayer의 props.onLoadedData)
        if (onLoadedData) {
            onLoadedData();
        }
    }, [
        onLoadedData,
        setLoading
    ]); // 외부 onLoadedData와 내부 setLoading을 의존성으로 추가
    // HLS 플레이어 훅 사용
    console.log('[useVideoPlayer] Src for HLS Player (using videoUrl directly):', videoUrl);
    var _useHlsPlayer = useHlsPlayer({
        videoElement: videoRef.current,
        src: videoUrl,
        autoPlay: autoPlay,
        onError: handleHlsPlayerError,
        onLoadedData: handleHlsPlayerLoadedData
    }), hlsLoading = _useHlsPlayer.loading, hlsError = _useHlsPlayer.error;
    // 호버 상태 핸들러 (다시 추가)
    var onMouseEnter = useCallback(function() {
        setIsHovered(true);
    }, []);
    var onMouseLeave = useCallback(function() {
        setIsHovered(false);
    }, []);
    // 오류 메시지 가져오기 (복원)
    var getVideoErrorMessage = function(errorCode) {
        switch(errorCode){
            case MediaError.MEDIA_ERR_ABORTED:
                return '비디오 재생이 중단되었습니다'; // Code 1
            case MediaError.MEDIA_ERR_NETWORK:
                return '네트워크 오류로 비디오를 재생할 수 없습니다'; // Code 2
            case MediaError.MEDIA_ERR_DECODE:
                return '비디오 디코딩 오류가 발생했습니다'; // Code 3
            case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
                return '비디오 형식이 지원되지 않거나 소스를 찾을 수 없습니다'; // Code 4
            default:
                return '비디오를 재생할 수 없습니다';
        }
    };
    // 네이티브 비디오 이벤트 핸들러
    var handleNativeError = useCallback(function(event) {
        var videoElement = event.currentTarget;
        var error = videoElement.error;
        var intendedSrc = src; // Check against the original src prop
        // *** 강화된 에러 무시 로직 ***
        // HLS 스트림에 대한 네이티브 "Empty src" (코드 4) 오류는 무시
        if ((error === null || error === void 0 ? void 0 : error.code) === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED && isHlsStream(intendedSrc)) {
            // 메시지까지 확인하여 "Empty src" 인 경우만 확실히 무시
            if (error.message.includes('Empty src') || error.message.includes('MEDIA_ELEMENT_ERROR: Empty src')) {
                console.log("네이티브 비디오 오류 코드 4 (".concat(error.message, ") 무시 (HLS 처리 예정)"));
                // 여기서 setError나 setLoading을 호출하지 않고 즉시 반환!
                return;
            } else {
                // 코드 4지만 메시지가 다른 경우 경고만 출력하고 아래에서 처리
                console.warn("네이티브 비디오 오류 코드 4 발생, 메시지 예상과 다름 (".concat(error.message, "). HLS 스트림이지만 처리 진행."));
            }
        }
        // --- 실제 네이티브 에러 처리 (위에서 return되지 않은 경우) ---
        var errorMessage = '알 수 없는 비디오 오류';
        if (error) {
            errorMessage = getVideoErrorMessage(error.code);
        }
        console.error('네이티브 비디오 오류:', errorMessage, error);
        setError(errorMessage);
        setLoading(false);
        if (onError) onError(new Error(errorMessage));
    }, [
        src,
        isHlsStream,
        setError,
        setLoading,
        onError
    ]); // src 의존성 추가
    var handleNativeLoadedData = useCallback(function() {
        console.log('네이티브 비디오 데이터 로드 완료');
        // HLS가 아닌 경우에만 로딩 상태 변경 및 콜백 호출
        if (!isHlsStream(videoUrl)) {
            setLoading(false);
            setError(null);
            if (onLoadedData) onLoadedData();
        }
    // HLS인 경우는 useHlsPlayer 훅의 콜백에서 처리됨
    }, [
        videoUrl,
        isHlsStream,
        setLoading,
        setError,
        onLoadedData
    ]);
    var handleNativeLoadStart = useCallback(function() {
        console.log('네이티브 비디오 로드 시작');
        // HLS가 아닌 경우에만 로딩 상태 변경
        if (!isHlsStream(videoUrl)) {
            setLoading(true);
            setError(null);
        }
    // HLS인 경우는 useHlsPlayer 훅에서 처리됨
    }, [
        videoUrl,
        isHlsStream,
        setLoading,
        setError
    ]);
    // 비디오 요소에 설정할 최종 src 결정
    var srcForVideoElement = isHlsStream(videoUrl) ? undefined : videoUrl;
    // 최종 로딩 상태 결정
    var finalLoading = isHlsStream(videoUrl) ? hlsLoading : loading;
    // 최종 에러 상태 결정
    var finalError = isHlsStream(videoUrl) ? hlsError : error;
    return {
        videoRef: videoRef,
        loading: finalLoading,
        error: finalError,
        isHovered: isHovered,
        posterUrl: posterUrl,
        videoUrl: videoUrl,
        srcForVideoElement: srcForVideoElement,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        hlsSupported: hlsSupported,
        hlsLoaded: hlsLoaded,
        isHlsStream: isHlsStream(videoUrl),
        // 네이티브 이벤트 핸들러 반환
        nativeOnError: handleNativeError,
        nativeOnLoadedData: handleNativeLoadedData,
        nativeOnLoadStart: handleNativeLoadStart
    };
}
